import API from './api';

const BASE = '/api/gcc-flows';

export const gccFlowsService = {
  // Ingestion
  uploadReport: (file, reportDate) => {
    const formData = new FormData();
    formData.append('file', file);
    if (reportDate) formData.append('report_date', reportDate);
    return API.post(`${BASE}/upload/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000,
    });
  },
  bulkUpload: (files) => {
    const formData = new FormData();
    files.forEach((f) => formData.append('files', f));
    return API.post(`${BASE}/upload/bulk/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 600000,
    });
  },
  previewExtract: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return API.post(`${BASE}/upload/preview/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000,
    });
  },
  getUploadHistory: () => API.get(`${BASE}/upload/history/`),
  ingestEmailsNow: () => API.post(`${BASE}/email/ingest-now/`, {}, { timeout: 300000 }),
  getEmailLog: (params) => API.get(`${BASE}/email/log/`, { params }),

  // Market flows
  getMarketOverview: (params) => API.get(`${BASE}/market-flows/overview/`, { params }),
  getMarketTrend: (params) => API.get(`${BASE}/market-flows/trend/`, { params }),
  getTopTickers: (params) => API.get(`${BASE}/market-flows/top-tickers/`, { params }),

  // Sector flows
  getSectorHeatmap: (params) => API.get(`${BASE}/sector-flows/heatmap/`, { params }),
  getSectorTrend: (params) => API.get(`${BASE}/sector-flows/trend/`, { params }),

  // Tickers
  searchTickers: (params) => API.get(`${BASE}/tickers/search/`, { params }),
  getTickerDetail: (market, ticker, params) =>
    API.get(`${BASE}/tickers/${encodeURIComponent(market)}/${encodeURIComponent(ticker)}/`, { params }),

  // Index events
  getIndexEvents: () => API.get(`${BASE}/index-events/`),
};
